import styled from 'styled-components';
import {
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
    FONT_PROPERTIES,
    FOCUS_CSS,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';

export const ZoomLinkOutContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    padding-bottom: 2rem;

    ${FONT_PROPERTIES}

    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;

export const Link = styled.a`
    display: inline-block;
    padding: 0.75rem 1.5rem;
    background-color: ${(props) => props.$backgroundColor};
    word-break: break-word;
    text-align: center;
    color: inherit;
    ${FOCUS_CSS}

    &:hover {
        color: ${(props) => props.$fontColorHover};
    }
`;
